import { EVENTS } from '../../../shared/config/event-constants';
import PermissionsMixin from './PermissionsMixin';

export default {
    mixins: [
        PermissionsMixin,
    ],
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        additional: {
            type: Object,
            default: () => {
                return {};
            },
        },
        params: {
            type: Object,
            default: () => {},
        },
        moduleCode: {
            type: String,
            default: null,
        },
        mapId: {
            type: String,
            default: null,
        },
        parentId: {
            type: [Number, String],
            default: null,
        },
        panelCfg: {
            type: Object,
            default: () => {},
        },
        baseTranslateID: {
            type: String,
        },
        labelDateFormat: {
            type: String,
            default: 'DD/MM/YYYY',
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss',
        },
    },
    data() {
        return {
        }
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID}`
        },
        defaultImage() {
            return {url: this.$root.$helper.theme.assetsPathGlobal('no-image.svg')};
        },
        actions() {
            return this.additional?.actions ?? {};
        }
    },
    methods: {
        highlightFeature(params) {
            const {feature, geojson, zoom = false, layerId = null} = params;
            if(feature || geojson) {
                this.$eventBus.publish(
                    this.moduleCode,
                    EVENTS.SELECT_FEATURE_CEMETERY,
                    {
                        feature,
                        geojson,
                        zoom,
                        layerId,
                    }
                );
            }
        },
    },
}